function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { getUserId, Identify, identify, init, setUserId, track } from "@amplitude/analytics-react-native";
import * as Sentry from "@sentry/core";
import { AMPLITUDE_API_KEY, AMPLITUDE_URL } from "../constants";
var analyticsInitialized = false;
export function initAnalytics() {
    if (!analyticsInitialized && AMPLITUDE_API_KEY && !global.e2e) {
        analyticsInitialized = true;
        init(AMPLITUDE_API_KEY, undefined, {
            trackingOptions: {
                ipAddress: false,
                adid: false
            },
            serverUrl: AMPLITUDE_URL
        });
    }
}
export function setUser(param) {
    var userID = param.userID, email = param.email;
    var sentryPayload = userID ? {
        id: userID
    } : null;
    if (sentryPayload && email) {
        sentryPayload.email = email;
    }
    Sentry.setUser(sentryPayload);
    if (!global.e2e) {
        setUserId(userID !== null && userID !== void 0 ? userID : undefined);
    }
}
export function setUserProperties(properties) {
    if (global.e2e) {
        return;
    }
    var identifyObj = new Identify();
    Object.entries(properties).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (typeof value !== 'undefined') {
            identifyObj.set(key, value);
        }
    });
    var user_id = getUserId();
    identify(identifyObj, {
        user_id: user_id
    });
}
export var addBreadcrumb = function(crumb) {
    Sentry.addBreadcrumb(crumb);
    if (!global.e2e && crumb.category !== 'mqtt-connection') {
        var eventName = crumb.category && crumb.message ? "".concat(crumb.category, ":").concat(crumb.message) : crumb.category || crumb.message || 'Unknown event';
        if (crumb.data) {
            track(eventName, crumb.data);
        } else {
            track(eventName);
        }
    }
};
export var logEvent = function(eventName, data) {
    if (global.e2e) {
        return;
    }
    if (data) {
        track(eventName, data);
    } else {
        track(eventName);
    }
};
